export enum FilterValueKey {
    englishName = 'englishName',
    code = 'code',
    country = 'country',
    depositTaxRate = 'depositTaxRate',
    taxations = 'taxations',
}
